import {Injectable} from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {catchError} from "rxjs/operators";
import {IndexConfigService} from "../_services/index.config.service";
import {throwError} from "rxjs";

@Injectable()
export class HttpRegInterceptor implements HttpInterceptor {

  constructor(public http: HttpClient, public config: IndexConfigService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.indexOf('logs/error') >= 0) {
      return next.handle(req);
    }
    let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    if (currentUser && currentUser.token) {
      req = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${currentUser.token}`),
      });
    }
    const res = next.handle(req);
    res['originalSubscribe'] = res.subscribe;
    res['subscribe'] = (param) => {
      const s = res['originalSubscribe'](param);
      window['requests'] = window['requests'] || [];
      window['requests'].push(s);


      return s;
    };

    const api = this.config.api;

    return res.pipe(catchError((r: HttpErrorResponse, caught: Observable<any>) => {
      this.http.post(api + '/api/logs/error', {status: r.status, server: r.headers['server'], requestUrl: r.url}).subscribe();
      return throwError(r);
    }));
  }
}
